module.exports = __webpack_public_path__ + "img/download.22822114.svg";